module.exports = __webpack_public_path__ + "media/images/menu/mars-73d53590cb39bea4da10fdab3de5e82a.jpg";